/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Icon } from '@components/atoms'

import { grey } from '@mui/material/colors'
import { useAppSelector, MenuType } from '@redux/index'
import { useLocation } from 'react-router-dom'

export const HomePathNav = () => {
	// hook
	const location = useLocation()

	// variables
	const menu: MenuType[] = useAppSelector(state => state.main.menu)

	const [path, setPath] = React.useState('')

	React.useEffect(() => {
		const newPath: string = getPath()
		setPath(`/ ${newPath}`)
	}, [location.pathname])

	const getPath = (): string => {
		const pathParts: string[] = location.pathname.replace('/', '').split('/')

		let prevTargetMenu: MenuType[] = []
		const result = pathParts.map((aPath: string, idx: number) => {
			const selectedMenu: MenuType[] =
				idx === 0
					? menu.filter((aMenu: MenuType) => aMenu.id === aPath)
					: prevTargetMenu.filter((aMenu: MenuType) => aMenu.id === aPath)

			if (selectedMenu[0].children !== undefined) {
				prevTargetMenu = [...selectedMenu[0].children]
			}

			if (selectedMenu[0].name !== undefined) {
				return selectedMenu[0].name
			}
		})

		return result.join('/ ')
	}

	return (
		<View css={style}>
			<Icon name="home" style={{ color: grey[500], fontSize: 18 }} />
			<Text category="p1" hint="500">
				{path}
			</Text>
		</View>
	)
}

const style = css({
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	marginTop: '-1rem',
})
